export class Field {
    constructor(
        public label: string, // tiêu đề
        public type: TypeField, // Loại trường
        public controlName: string, // formControlName 
        public placeholder?: string | null, //placeholder
        public required?: boolean | null, // trường bắt buộc nhập
        public disable?: boolean | null, // disable 
        public numberCol?: number | null, // phần của các colSpan field, chia là 24 phần
        public value?: any | null , // giá trị
        public nzMode?: ModeFieldDate | null, // nếu type là DATETIME
        public options?: optionsField[] | null , // các tùy chọn của checkbox hoặc select
        public validatorCustom?: validatorCustom[], //  tùy chọn validate
        public autoComplete?: any, //  tùy chọn validate
        public handlerSelected?: Handler, // xử lý sự kiện khi chọn giá trị select autoComplete
    ){}
}

export enum TypeField{
    INPUT = 'text',
    SELECT = 'select',
    DATETIME = 'datetime',
    SELECT_AUTOCOMPLETE = 'selectAutoComplete',
    NUMBER = 'number',
    CHECKBOX = 'checkbox',
    RADIO ='radio',
    RANGEPICKER = 'rangepicker',
}

export enum ModeFieldDate{
    YEAR = 'year',
    DATE = 'date',
    WEEK = 'week',
    MONTH = 'month',
}
export interface optionsField{
    key: any;
    lable: string;
}
export class validatorCustom{
    constructor( public validator: any,  public nameValidator: string, public messegaError:string  ){
    }
}
type Handler = (any) => void;